import { c as _c } from "react/compiler-runtime";
import { Button, Center } from '@chakra-ui/react';
type AdvisorsLoadMoreProps = {
  hasNextPage?: boolean | null;
  loading?: boolean;
  label?: string;
  onLoadMore: () => void;
};

/** Shared Load more control for Advisors collection lists and grids. */
export const AdvisorsLoadMore = t0 => {
  const $ = _c(6);
  const {
    hasNextPage,
    loading: t1,
    label: t2,
    onLoadMore
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const label = t2 === undefined ? "Load more" : t2;
  if (!hasNextPage) {
    return null;
  }
  let t3;
  if ($[0] !== onLoadMore) {
    t3 = () => {
      onLoadMore();
    };
    $[0] = onLoadMore;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label || $[3] !== loading || $[4] !== t3) {
    t4 = <Center paddingTop={2} width="full"><Button loading={loading} size="sm" variant="outline" width="full" onClick={t3}>{label}</Button></Center>;
    $[2] = label;
    $[3] = loading;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};